import cloneDeep from 'lodash.clonedeep';
import uuid from 'uuid/v4';

export default function pasteScenesIntoScribe(scribe, clipboard, selectedSceneIds = []) {
  const clonedScribe = cloneDeep(scribe);

  const pastePosition = selectedSceneIds.length
    ? Math.max(...selectedSceneIds.map(sceneId => clonedScribe.scenes.findIndex(scene => scene.id === sceneId))) + 1
    : clonedScribe.scenes.findIndex(scene => scene.active) + 1;

  const newElements = [];
  const newScenes = clipboard.data.map(clipboardScene => {
    const clonedScene = cloneDeep(clipboardScene);
    clonedScene.id = uuid();

    clonedScene.elementIds.forEach((elementId, index, arr) => {
      const clonedElement = cloneDeep(clipboard.metadata.elements.find(element => element.tempId === elementId));
      clonedElement.id = uuid();

      arr[index] = clonedElement.id;
      delete clonedElement.tempId;
      newElements.push(clonedElement);
    });

    return clonedScene;
  });

  clonedScribe.elements = [...clonedScribe.elements, ...newElements];
  clonedScribe.scenes.splice(pastePosition, 0, ...newScenes);

  const lastSceneId = newScenes.length ? newScenes[newScenes.length - 1].id : null;

  return { updatedScribe: clonedScribe, lastSceneId };
}
